import React, {useEffect, useState} from 'react'
import './App.css'
import Main from './components/Main'
import {BrowserRouter as Router, Navigate, Route, Routes} from 'react-router-dom'
import StoreCard from './components/StoreCard'
import {Provider, useSelector} from 'react-redux'
import apiConfigured from './slice/ApiSlice'
import Rewards from './components/Rewards'
import FontPicker from 'react-fontpicker-ts-lite'
import {fonts} from './components/FontInfo'
import GlobalErrorHandler from './components/GlobalErrorHandler'
import GoogleAuth from "./components/GoogleSignin";
import Panel from "./components/Panel";
import {selectAuth} from "./slice/AuthSlice";

const ProtectedRoute: React.FC<{ authenticated: boolean; element: React.ReactElement }> = ({
                                                                                             authenticated,
                                                                                             element,
                                                                                           }) => {
  if (!authenticated) {
    return <GoogleAuth/>
  }
  return element
}


function App() {
  const [fontIndex, setFontIndex] = useState(10)

  useEffect(() => {
    if (fontIndex <= 80) {
      setFontIndex(fontIndex + 10)
    }
  }, [fontIndex])

  function AppRoutes() {
    const token = localStorage.getItem('token')

    return (
      <Routes>
        <Route path="/login" element={<GoogleAuth/>}/>
        <Route element={<ProtectedRoute authenticated={token !== null} element={<Panel/>}/>}>
          <Route path="/" element={<Main/>}/>
          <Route path="/:id/rewards" element={<Rewards/>}/>
          <Route path="/:id" element={<StoreCard/>}/>
        </Route>
        <Route
          path="*"
          element={<Navigate to={token !== null ? '/' : '/login'} replace/>}
        />
      </Routes>
    )
  }

  return (
    <Provider store={apiConfigured}>
      <GlobalErrorHandler/>
      <FontPicker loaderOnly loadFonts={fonts.slice(0, fontIndex)}/>
      <Router>
        <AppRoutes/>
      </Router>
    </Provider>
  )
}

export default App
